export class Extras {
	constructor (attributes) {
		var extras = attributes

		if (!extras) return null

		return extras
	}
}
